var BaseViews = require('../../base');
var algoliasearch = require('algoliasearch/lite');
var autocomplete = require('autocomplete.js');
require('./algolia-autocomplete.scss');
var Spinner = require('treeline-shared-components/spinner');

var AlgoliaAutocomplete = BaseViews.LayoutView.extend({
    className: 'algolia-autocomplete-container',

    initialize: function(options) {
        this.options = options || {};
        this.searchClient = algoliasearch(
            this.options.algoliaAppId,
            this.options.algoliaSearchApiKey
        );
        
        // Get current filter location
        this.filterLocation = this.options._appChannel.request('get:filter:location');
        
        // Listen for location changes
        this.listenTo(this.options._appChannel, 'search:options:changed', this.handleLocationChange);

        // Add after initialize function
        this._currentPage = 0;
        this._isLoading = false;
        this._hasMoreResults = true;
        this._currentQuery = '';
        this._currentHits = [];
        this.options.disableAnalytics = !!this.options.disableAnalytics;
    },

    onRender: function() {
        this.initAutocomplete();
    },
    handleLocationChange: function(options) {
        if (options.location) {
            this.filterLocation = options.location;
            // Reinitialize autocomplete with new location
            this.closeAutocomplete();
            this.initAutocomplete();
        }
    },
    template: function () {
        return `
            <div class="aa-input-wrapper">
                <svg class="aa-search-icon" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>
                <input type="search" placeholder="Search products..." class="aa-input">
                <svg class="aa-clear-icon" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
            </div>
            <div class="tl-loader-region"></div>
        `;
    },
    _clearInfiniteScrollResults: function() {
        const dropdown = this.el.querySelector('.aa-dropdown-menu');
        if (dropdown) {
            // Remove all infinite scroll containers
            const containers = dropdown.querySelectorAll('.aa-infinite-scroll-results');
            containers.forEach(container => container.remove());
            // Reset scroll position
            dropdown.scrollTop = 0;
        }
    },
    initAutocomplete: function() {
        const input = this.el.querySelector('input');
        if (!input) return;
        var self = this;
        
        const searchSource = function(query, callback) {
            // Reset pagination when query changes
            if (query !== self._currentQuery) {
                self._currentPage = 0;
                self._currentHits = [];
                self._hasMoreResults = true;
                self._currentQuery = query;
                
                // Clear infinite scroll results and reset scroll position
                self._clearInfiniteScrollResults();
            }

            const filterLocation = self.filterLocation || 'downtownvictoria';
            const filterString = `(status:published) AND (in_stock_${filterLocation}:true)`;
            
            self.searchClient.initIndex(self.options.indexName)
                .search(query, {
                    filters: filterString,
                    hitsPerPage: 20,
                    page: self._currentPage,
                    analytics: self.options.disableAnalytics ? false : undefined
                })
                .then(function(content) {
                    self._hasMoreResults = self._currentPage < content.nbPages - 1;
                    self._currentHits = self._currentPage === 0 ? 
                        content.hits : 
                        [...self._currentHits, ...content.hits];
                    
                    // Hide loader after results are received
                    if (self._loader) {
                        self.loaderRegion.empty();
                        self._loader = null;
                    }
                    self._isLoading = false;
                    
                    callback(self._currentHits);
                });
        };

        this.autocomplete = autocomplete(input, {
            hint: false,
            debug: false,
            minLength: 1,
            autoselect: false,
            cssClasses: {
                dropdown: 'aa-dropdown-menu',
                suggestion: 'aa-suggestion'
            }
        }, [{
            source: searchSource,
            displayKey: 'title',
            templates: {
                suggestion: function(suggestion) {
                    return self.renderProductItem(suggestion);
                }
            }
        }]);

        this.autocomplete.on('autocomplete:selected', function(event, suggestion) {
            self.options._appChannel.request('load:product:url', suggestion.slug);
            self.options._appChannel.trigger('menu:search:view:close');
        });

        input.addEventListener('keydown', function(e) {
            self._handleKeydown(e);
        });

        const dropdown = this.el.querySelector('.aa-dropdown-menu');
        if (dropdown) {
            const throttledScroll = _.throttle(function() {
                self._handleScroll();
            }, 200);
            dropdown.addEventListener('scroll', throttledScroll);
        }

        // Focus the input field after initialization
        setTimeout(function() {
            input.focus();
        }, 0);
    },

    _handleKeydown: function(e) {
        const dropdownMenu = this.el.querySelector('.aa-dropdown-menu');
        if (!dropdownMenu || dropdownMenu.style.display === 'none') return;

        const items = Array.from(dropdownMenu.querySelectorAll('.aa-ItemWrapper'));
        if (!items.length) return;

        let currentIndex = items.findIndex(item => item.classList.contains('aa-cursor'));
        
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                currentIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                this._highlightSuggestion(items, currentIndex);
                this._scrollIntoViewIfNeeded(items[currentIndex], dropdownMenu);
                break;
                
            case 'ArrowUp':
                e.preventDefault();
                currentIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                this._highlightSuggestion(items, currentIndex);
                this._scrollIntoViewIfNeeded(items[currentIndex], dropdownMenu);
                break;
                
            case 'Enter':
                e.preventDefault();
                if (currentIndex >= 0) {
                    items[currentIndex].click();
                }
                break;
        }
    },

    _highlightSuggestion: function(items, index) {
        items.forEach(item => {
            item.classList.remove('aa-cursor');
            const wrapper = item.closest('.aa-ItemWrapper');
            if (wrapper) {
                wrapper.classList.remove('aa-cursor');
            }
        });

        if (index >= 0 && index < items.length) {
            items[index].classList.add('aa-cursor');
            const wrapper = items[index].closest('.aa-ItemWrapper');
            if (wrapper) {
                wrapper.classList.add('aa-cursor');
            }
        }
    },

    _scrollIntoViewIfNeeded: function(element, container) {
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        if (elementRect.bottom > containerRect.bottom) {
            element.scrollIntoView(false);
        } else if (elementRect.top < containerRect.top) {
            element.scrollIntoView(true);
        }
    },

    renderProductItem: function(hit) {
        const primaryImage = _.find(hit.images, { is_primary: "1" });
        const thumbnailUrl = primaryImage ? primaryImage.thumb_url : hit.preview_image;
        
        // Get highlighted categories
        const highlightedCategories = (hit.display_categories || [])
            // Remove duplicates
            .filter((category, index, self) => self.indexOf(category) === index)
            .filter(function(category) {
                return hit._highlightResult && 
                       hit._highlightResult.display_categories && 
                       hit._highlightResult.display_categories.some(function(h) {
                            return h && h.value && h.matchLevel !== 'none' &&
                                   category.toLowerCase() === 
                                   h.value.toLowerCase()
                                       .replace(/<\/?em>/g, '')
                                       .replace(/__aa-highlight__|__\/aa-highlight__/g, '');
                       });
            })
            .map(function(category) {
                const highlightedValue = hit._highlightResult && 
                                       hit._highlightResult.display_categories && 
                                       hit._highlightResult.display_categories.find(function(h) {
                    return h && h.value && h.matchLevel !== 'none' &&
                           category.toLowerCase() === 
                           h.value.toLowerCase()
                               .replace(/<\/?em>/g, '')
                               .replace(/__aa-highlight__|__\/aa-highlight__/g, '');
                });

                if (!highlightedValue) {
                    return category;
                }

                // Convert Algolia's <em> tags to underline tags
                return highlightedValue.value
                    .replace(/<em>/g, '<u>')
                    .replace(/<\/em>/g, '</u>');
            });
            
        // Safely get highlighted values
        const getHighlightedValue = function(hit, field) {
            const value = hit._highlightResult && 
                   hit._highlightResult[field] && 
                   hit._highlightResult[field].value ? 
                   hit._highlightResult[field].value : 
                   hit[field] || '';
            
            // Convert Algolia's <em> tags to bold tags
            return value.replace(/<em>/g, '<u>').replace(/<\/em>/g, '</u>');
        };

        const getHighlightedContent = function(hit) {
            const content = hit.description;
            if (!content) return '';
            
            // Get highlighted description with pre-marked highlights from Algolia
            const highlightedDescription = hit._highlightResult && 
                                         hit._highlightResult.description && 
                                         hit._highlightResult.description.value || content;
            
            const segments = [];
            
            // Add first 70 characters
            const firstSegment = highlightedDescription.substring(0, 70);
            segments.push(firstSegment.replace(/<em>/g, '<u>').replace(/<\/em>/g, '</u>'));
            
            // Find all highlighted matches in the remaining content
            const remainingContent = highlightedDescription.slice(70);
            const matches = [];
            let match;
            const highlightRegex = /<em>(.+?)<\/em>/g;
            
            while ((match = highlightRegex.exec(remainingContent)) !== null) {
                matches.push({
                    start: match.index,
                    end: match.index + match[0].length,
                    text: match[0]
                });
            }
            
            // If we found matches, add context around them
            if (matches.length > 0) {
                segments.push('...');
                
                matches.slice(0, 2).forEach(function(match, index) {
                    const segmentStart = Math.max(0, match.start - 35);
                    const segmentEnd = Math.min(remainingContent.length, match.end + 35);
                    
                    if (index > 0 && segmentStart - matches[index - 1].end > 70) {
                        segments.push('...');
                    }
                    
                    const segment = remainingContent.substring(segmentStart, segmentEnd);
                    segments.push(segment.replace(/<em>/g, '<u>').replace(/<\/em>/g, '</u>'));
                });
            }
            
            if (content.length > 70 || segments.length > 1) {
                segments.push('...');
            }
            
            return segments.join('');
        };

        return [
            '<div class="aa-ItemWrapper">',
                '<div class="aa-ItemContent">',
                    thumbnailUrl ? [
                        '<div class="aa-ItemIcon aa-ItemIcon--alignTop">',
                            '<img ',
                                'src="' + thumbnailUrl + '" ',
                                'alt="' + hit.title + '"',
                            '/>',
                        '</div>'
                    ].join('') : '',
                    '<div class="aa-ItemContentBody">',
                        '<div class="aa-ItemContentTitle">',
                            getHighlightedValue(hit, 'vendor_name'),
                            ' - ',
                            getHighlightedValue(hit, 'title'),
                        '</div>',
                        '<div class="aa-ItemContentDescription">',
                            getHighlightedContent(hit),
                        '</div>',
                        hit._highlightResult && 
                        hit._highlightResult.strain && 
                        hit._highlightResult.strain.matchedWords && 
                        hit._highlightResult.strain.matchedWords.length ? [
                            '<div class="aa-ItemContentDescription">',
                                'Strain: ' + getHighlightedValue(hit, 'strain'),
                            '</div>'
                        ].join('') : '',
                        highlightedCategories.length ? [
                            '<div class="auto-complete-list aa-ItemContentDescription">',
                                'Categories: ' + highlightedCategories.join(', '),
                            '</div>'
                        ].join('') : '',
                    '</div>',
                '</div>',
            '</div>'
        ].join('');
    },
    closeAutocomplete: function() {
        if (this.autocomplete) {
            this.autocomplete.autocomplete.close();
            const input = this.el.querySelector('.aa-input');
            const dropdown = this.el.querySelector('.aa-dropdown-menu');
            if (dropdown) {
                dropdown.removeEventListener('scroll', this._handleScroll);
            }
            if (input) {
                input.autocomplete = null;
                input.removeEventListener('keydown', this._handleKeydown);
            }
            this.autocomplete = null;
        }
    },
    onDestroy: function() {
        this.closeAutocomplete();
    },

    events: {
        'click .aa-clear-icon': 'clearSearch',
        'input .aa-input': 'toggleClearButton'
    },

    clearSearch: function() {
        const input = this.el.querySelector('.aa-input');
        if (input) {
            input.value = '';
            input.focus();
            this.toggleClearButton();
            if (this.autocomplete) {
                this.autocomplete.autocomplete.setVal('');
            }
        }
    },

    toggleClearButton: function() {
        const input = this.el.querySelector('.aa-input');
        const clearButton = this.el.querySelector('.aa-clear-icon');
        if (input && clearButton) {
            clearButton.style.display = input.value ? 'block' : 'none';
        }
    },

    regions: {
        loaderRegion: '.tl-loader-region'
    },

    _loadMoreResults: function() {
        if (!this._currentQuery || this._isLoading || !this._hasMoreResults) {
            return;
        }

        this._isLoading = true;
        this._currentPage++;
        
        // Set up a timer to show the loader after 400ms if still loading
        let loaderTimeout = setTimeout(() => {
            if (this._isLoading && !this._loader) {
                this._loader = new Spinner({
                    message: 'Loading more results...',
                });
                this.loaderRegion.show(this._loader);
                
                // Make sure the loader region is visible
                const loaderRegion = this.el.querySelector('.tl-loader-region');
                if (loaderRegion) {
                    loaderRegion.style.display = 'block';
                }
            }
        }, 400);

        const filterLocation = this.filterLocation || 'downtownvictoria';
        const filterString = `(status:published) AND (in_stock_${filterLocation}:true)`;
        
        this.searchClient.initIndex(this.options.indexName)
            .search(this._currentQuery, {
                filters: filterString,
                hitsPerPage: 20,
                page: this._currentPage,
                analytics: this.options.disableAnalytics ? false : undefined
            })
            .then((content) => {
                // Clear the timeout to prevent loader from showing if we finish quickly
                clearTimeout(loaderTimeout);
                
                this._hasMoreResults = this._currentPage < content.nbPages - 1;
                this._currentHits = [...this._currentHits, ...content.hits];
                
                if (this._loader) {
                    this.loaderRegion.empty();
                    this._loader = null;
                }
                this._isLoading = false;
                
                const dropdown = this.el.querySelector('.aa-dropdown-menu');
                if (dropdown) {
                    const container = document.createElement('div');
                    container.className = 'aa-infinite-scroll-results';
                    
                    const hitMap = new Map();
                    content.hits.forEach(hit => {
                        const itemHtml = this.renderProductItem(hit);
                        container.insertAdjacentHTML('beforeend', itemHtml);
                        
                        const itemElements = container.querySelectorAll('.aa-ItemWrapper');
                        const lastItem = itemElements[itemElements.length - 1];
                        hitMap.set(lastItem, hit);
                    });
                    
                    dropdown.appendChild(container);
                    
                    const self = this;
                    hitMap.forEach((hit, element) => {
                        element.addEventListener('click', function(e) {
                            self.options._appChannel.request('load:product:url', hit.slug);
                            self.options._appChannel.trigger('menu:search:view:close');
                        });
                    });
                }
            })
            .catch((error) => {
                // Clear the timeout on error as well
                clearTimeout(loaderTimeout);
                
                console.error('Error loading more results:', error);
                this._isLoading = false;
                if (this._loader) {
                    this.loaderRegion.empty();
                    this._loader = null;
                }
            });
    },

    _handleScroll: function() {
        const dropdown = this.el.querySelector('.aa-dropdown-menu');
        if (!dropdown) {
            console.log('No dropdown found');
            return;
        }

        const scrollTop = dropdown.scrollTop;
        const scrollHeight = dropdown.scrollHeight;
        const clientHeight = dropdown.clientHeight;

        if (!this._isLoading && 
            this._hasMoreResults && 
            scrollTop + clientHeight >= scrollHeight - 100) {
            this._loadMoreResults();
        }
    },

    source: function(query, callback) {
        // Reset pagination when query changes
        if (query !== self._currentQuery) {
            self._currentPage = 0;
            self._currentHits = [];
            self._hasMoreResults = true;
            self._currentQuery = query;
        }

        const filterLocation = self.filterLocation || 'downtownvictoria';
        const filterString = `(status:published) AND (in_stock_${filterLocation}:true)`;
        
        self.searchClient.initIndex(self.options.indexName)
            .search(query, {
                filters: filterString,
                hitsPerPage: 20,
                page: self._currentPage,
                analytics: self.options.disableAnalytics ? false : undefined
            })
            .then(function(content) {
                self._hasMoreResults = self._currentPage < content.nbPages - 1;
                self._currentHits = self._currentPage === 0 ? 
                    content.hits : 
                    [...self._currentHits, ...content.hits];
                
                // Hide loader after results are received
                if (self._loader) {
                    self.loaderRegion.empty();
                    self._loader = null;
                }
                self._isLoading = false;
                
                callback(self._currentHits);
            });
    }
});

module.exports = AlgoliaAutocomplete;


/** WEBPACK FOOTER **
 ** ./assets/js/common/search/algolia-autocomplete/index.js
 **/